/**
*  DoughnutChart.vue
**/
/* template import */
<template src="./doughnut-chart.html"></template>
/* style import */
<style scoped lang="scss" src="./doughnut-chart.scss"></style>
<script>
import * as d3 from 'd3'
import customFormatters from '@/filters/customFormatters'

export default {
  name: 'DoughnutChart',
  mixins: [customFormatters],
  components: {},
  props: {
    chartData: {
      type: Array,
      required: true
    },
    type: {
      type: String,
      default: 'generic',
      required: false,
      validator (value) {
        const types = [
          'generic',
          'gender'
        ]
        return types.indexOf(value) !== -1
      }
    }
  },
  data () {
    return {
      tooltipData: {
        key: '',
        value: ''
      }
    }
  },
  mounted () {
    this.drawChart()
  },
  methods: {
    async drawChart () {
      const wrapper = this.$refs.wrapper.getBoundingClientRect()
      const radius = Math.min(wrapper.width, wrapper.height)
      const center = radius / 2
      const arcSize = 16
      const padding = 0
      const colors = this.chartData.length > 2 ? ['#5fc3d4', '#f0a65e', '#9397a2'] : ['#5fc3d4', '#9397a2']
      const colorScale = d3.scaleOrdinal().range(colors)
      const pie = d3.pie().value((d) => d.value).padAngle(0)

      const svg = d3.select(this.$refs.svg)
        .attr('width', `${wrapper.width}px`)
        .attr('height', `${wrapper.height}px`)

      const g = svg.append('g')
        .attr('transform', `translate(${wrapper.width / 2}, ${wrapper.height / 2})`)

      this.chartData.forEach((data, i) => {
        const arc = d3.arc()
          .innerRadius(((center - arcSize) - padding) - ((arcSize + padding) * i))
          .outerRadius((center - padding) - ((arcSize + padding) * i))

        g.append('g')
          .attr('class', 'donut')
          .selectAll('path')
          .data(pie(data.data))
          .enter()
          .append('path')
          .attr('class', 'path')
          .attr('d', arc)
          .attr('fill', d => d.data.color || colorScale(i))
          .attr('stroke', 'white')
          .attr('stroke-width', '1px')
          .style('opacity', (d, n) => (1 - (n * 0.3)))
          .on('mouseover', d => this.showTooltip(d, d.data.color || colorScale(i)))
          .on('mousemove', d => this.moveTooltip())
          .on('mouseout', d => this.hideTooltip())
      })
    },
    showTooltip (data, color) {
      this.tooltipData = {
        key: data.data.key,
        value: parseFloat(data.data.value),
        color: color
      }
      this.$refs.tooltip.style.opacity = 1
    },
    moveTooltip () {
      this.$refs.tooltip.style.left = d3.event.offsetX + 'px'
      this.$refs.tooltip.style.top = (d3.event.clientY - this.$refs.tooltip.offsetHeight * 2) + 'px'
    },
    hideTooltip () {
      this.$refs.tooltip.style.opacity = 0
    }
  }
}
</script>
